<template>
  <resource-loader :task="task" :resource="modelValue">
    Client not found.
  </resource-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  DetailedClient,
} from '@/type';
import { HasTaskMixin } from '@/mixins';
import ResourceLoader from '@/components/loading/ResourceLoader.vue';
import repository from './client-repository';

interface Data {
  task: Promise<DetailedClient>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    ResourceLoader,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => DetailedClient,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.clientId);
      this.task.then((client) => {
        this.$emit('update:modelValue', client);
        this.$emit('loaded', client);
      });
    },
  },
});
</script>
